/**
 * Sprint BJ Part 1 — リカバリコードを localStorage に保存 / 読出 / 削除する pure helper。
 *
 * 用途: `RecoveryCodeModal` 発行成功時に option で永続化 → `RecoveryAutoPage` (deep link 経路) が
 *      自動読込 → recoverParticipant 自動実行 (旧 `old/apps/user/src/pages/RecoveryAutoPage.tsx` 踏襲)。
 *
 * 設計:
 *   - **districtId 別保管**: 旧は `setMeta('recoveryCode:{districtId}', code)` (IndexedDB) で
 *     district 別、v2 も同じく district 別 (key prefix + districtId)。
 *   - **localStorage 採用** (旧の IndexedDB 経由ではなく): SSR safe + `useNickname.ts` と同 pattern で
 *     既存規律 (cw.* prefix) と一致させる。RecoveryAuto は deep link 直叩きで一度しか読まないため
 *     IndexedDB の async read を経由する必要なし。
 *   - 失敗 (quota / private mode 等) は silently 握りつぶし (caller 側で値なしと等価扱い)。
 */

const STORAGE_KEY_PREFIX = 'cw.recoveryCode.v1.';

export function recoveryCodeKey(districtId: string): string {
  return `${STORAGE_KEY_PREFIX}${districtId}`;
}

export function loadRecoveryCode(districtId: string): string | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const v = localStorage.getItem(recoveryCodeKey(districtId));
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

export function persistRecoveryCode(districtId: string, code: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    if (code === '') {
      localStorage.removeItem(recoveryCodeKey(districtId));
    } else {
      localStorage.setItem(recoveryCodeKey(districtId), code);
    }
  } catch {
    /* quota / private mode 等は無視 */
  }
}

export function clearRecoveryCode(districtId: string): void {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(recoveryCodeKey(districtId));
  } catch {
    /* noop */
  }
}
